import script from "./PoliticaTermos.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaTermos.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaTermos.vue?vue&type=style&index=0&id=9c08a44c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c08a44c"]])

export default __exports__